var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27.8,
    height: 29,
    rx: 13.9,
    stroke: "#343A40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0892 6.00003C15.2318 6.00003 16.1552 6.93494 16.1552 8.08338C16.1552 9.2376 15.2203 10.1552 14.0545 10.1552C12.9119 10.1494 11.9943 9.21451 12 8.0603C12.0058 6.91763 12.9349 5.99426 14.0892 6.00003Z",
    fill: "#343A40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.066 17.0771C12.9234 17.0713 12 16.1422 12 14.9937C12 13.8395 12.9349 12.9161 14.1007 12.9219C15.2433 12.9277 16.1609 13.8626 16.1552 15.0168C16.1494 16.1595 15.2203 17.0771 14.066 17.0771Z",
    fill: "#343A40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1552 21.9349C16.1552 23.0776 15.2261 24.001 14.0718 24.001C12.9176 24.001 11.9943 23.0661 12 21.9061C12.0058 20.7634 12.9407 19.8458 14.0892 19.8516C15.2376 19.8574 16.1552 20.7865 16.1552 21.9349Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionImg);
export default __webpack_public_path__ + "static/media/action-img.b9d5f931f20db1bee517d7525c5d263f.svg";
export { ForwardRef as ReactComponent };